export default __webpack_public_path__ + "static/media/4.48810082.jpg";